import DeliveryOption from '@/controllers/options/DeliveryOption';
import DeliveryOptionsProvider from '@/models/DeliveryOptionsProvider';
import IOptionHandler from './IOptionHandler';

class BasicOptionHandler implements IOptionHandler {
  private readonly expectedKey: string;
  constructor(expectedTool: string) {
    this.expectedKey = expectedTool;
  }

  execute(provider: DeliveryOptionsProvider, map: Map<string, unknown>): void {
    if (map.get(this.expectedKey)) {
      const deliveryOption: DeliveryOption = new DeliveryOption(this.expectedKey);
      deliveryOption.addSetting('value', 'true');
      provider.addDeliveryOption(deliveryOption);
    }
  }
}

export default BasicOptionHandler;
